// extracted by mini-css-extract-plugin
export default {"td":"TableRow_td__V3tjE"};